<template>
  <div class="form-control-plaintext">
    {{value_}}
  </div>
</template>

<script>
import InputMasked from './InputMasked.vue'

export default {
  name: 'DisplayMasked',
  extends: InputMasked,
}
</script>
